import type { Fetch } from '../types'

const estUriAbsolue = /^https?:\/\//i

export function configUriHelperFactory(baseUrl: string) {
  return function configUriHelper(nextFetch: Fetch): Fetch {
    return function (input: RequestInfo | URL, init?: RequestInit) {
      if (typeof input === 'string') {
        if (estUriAbsolue.test(input) === false) {
          input = `${baseUrl}${input}`
        }
      }
      return nextFetch(input, init)
    }
  }
}
